import React, { useCallback, useEffect, useState } from 'react'
import dayjs from 'dayjs'
import { useDispatch, useSelector } from 'react-redux'
import {
  addRangeOfDays,
  getCurrentDate
} from '../../../../domain/features/ui/rangeOfDaysSlice'
import InputRangeDate from '../../atomics/Input/InputRangeDate'

const RangeOfDays = () => {
  const date = useSelector(getCurrentDate)
  const dispatch = useDispatch()

  // Estado local para el display mientras el usuario está seleccionando.
  // Solo se despacha a Redux cuando ambas fechas están elegidas, evitando
  // que el re-render cierre el calendario antes de seleccionar la fecha fin.
  const [localDate, setLocalDate] = useState(date)

  // Sincroniza si Redux cambia externamente (ej: inicialización desde URL params)
  useEffect(() => {
    setLocalDate(date)
  }, [date])

  const handleDateChange = useCallback(
    value => {
      setLocalDate(value)
      if (value[0] && value[1]) {
        dispatch(
          addRangeOfDays([
            dayjs(value[0]).startOf('day').toDate(),
            dayjs(value[1]).endOf('day').toDate()
          ])
        )
      }
    },
    [dispatch]
  )

  return (
    <InputRangeDate prefixName="Fecha" value={localDate} onChange={handleDateChange} />
  )
}

export default RangeOfDays
